import { RELATED_SEARCHES_EXPERIENCE } from 'constants/TestTarget';

const MAX_RELATED_SEARCH_TERMS = 8; // BR-003 / AC-006/007 (shell-owned cap)
const MIN_RELATED_SEARCH_TERMS = 3; // BR-002 / AC-008
const MIN_PRODUCT_ROWS = 2; // BR-004 / AC-009/021

// Single visibility source: the SAME predicate gates the grid reservation AND the shell render.
// Eligible iff challengerOne variant AND >=3 terms AND >=2 product rows.
const isRelatedSearchesEligible = (variant, terms, productRowsCount) =>
    variant === RELATED_SEARCHES_EXPERIENCE.CHALLENGER_ONE &&
    (terms?.length || 0) >= MIN_RELATED_SEARCH_TERMS &&
    productRowsCount >= MIN_PRODUCT_ROWS;

export {
    MAX_RELATED_SEARCH_TERMS, MIN_RELATED_SEARCH_TERMS, MIN_PRODUCT_ROWS, isRelatedSearchesEligible
};
